<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card elevation="6">
        <div class="pa-2">
          <v-card-title>
            <v-text-field color="#86bc3a" v-model="search" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="data_list" :footer-props="footer_Props" :search="search" mobile-breakpoint="0">
            <template v-slot:item="dataDetail">
              <tr>
                <td>{{ dataDetail.item.refund_code }}</td>
                <td>{{ dataDetail.item.date }}</td>
                <td>
                  <div>{{ dataDetail.item.customer_type }}</div>
                </td>
                <td>
                  <div>{{ dataDetail.item.name }}</div>
                </td>
                <td>
                  <div>{{ dataDetail.item.telephone }}</div>
                </td>
                <td>{{ dataDetail.item.refund_reason }}</td>
                <td>
                  <div v-if="dataDetail.item.refund_status === 3" class="black--text">ปฎิเสธการรับคืน</div>
                  <div v-if="dataDetail.item.refund_status === 4" class="primary_color">เสร็จสิ้น</div>
                </td>
                <td class="pa-3">
                  <v-btn small height="42" class="grad-success-bg white--text mr-1 mb-1" @click="get_detail(dataDetail.item.id)">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Refund_process_success",
  data() {
    return {
      loading_page: false,
      search: '',
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'เลขที่การคืน',
          value: 'refund_code',
          fixed: true,
          width: '180px',
        },
        {
          text: 'วันที่',
          value: 'date',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ประเภทลูกค้า',
          value: 'customer_type',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ชื่อลูกค้า',
          value: 'name',
          fixed: true,
          width: '220px',
        },
        {
          text: 'เบอร์โทรติดต่อ',
          value: 'telephone',
          fixed: true,
          width: '160px',
        },
        {
          text: 'สาเหตุ',
          value: 'refund_reason',
          fixed: true,
          width: '180px',
        },
        {
          text: 'สถานะ',
          value: 'refund_status',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จัดการ',
          value: '',
          fixed: true,
          sortable: false,
          width: '150px',
        },
      ],
      data_list: [],
    }
  },
  methods: {
    get_data() {
      this.loading_page = true
      HTTP.post('/refunds/all', {
        status: 1
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.data_list = res.data.object
        }
      })
    },
    get_detail(id) {
      this.$router.push('/refund/refunddetail/' + id)
    }
  },
  mounted () {
    this.get_data()
  }
}
</script>

<style scoped>

</style>
